import React, { useEffect, useState, useRef } from "react";
import FileUpload from "../../components/Attachment/Attachment";
import { Col, Row } from "react-bootstrap";
function Attachments({ attachmnetid, status }) {
  return (
    <Row className="justify-content-md-center">
      <Col md="10">
        <FileUpload
          status={status}
          moduleType={"ORDER"}
          attachmnetid={attachmnetid}
          maxFiles={20}
          maxFileSize={20}
          onFilesChange={(updatedFiles) => console.log(updatedFiles)}
        />
      </Col>
    </Row>
  );
}

export default Attachments;
